// src/components/ReservationStats.jsx
import React from "react";

const boxStyle = {
  background: "#ffffff",
  padding: "14px",
  borderRadius: "10px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
  textAlign: "center",
};

const titleStyle = {
  margin: 0,
  fontSize: "13px",
  color: "#666",
  fontWeight: 600,
};

const valueStyle = {
  marginTop: "6px",
  fontSize: "20px",
  fontWeight: 500,
  color: "#2c9c84",
};

const calcStay = (inDate, outDate) =>
  Math.ceil((new Date(outDate) - new Date(inDate)) / (1000 * 60 * 60 * 24));

const ReservationStats = ({ reservations }) => {
  console.log(reservations);

  // ❌ Cancelled reservations excluded from calculations
  const activeReservations = reservations.filter(
    (r) =>
      r.reservationType !== "Cancelled" &&
      r.reservationType !== "Cancelled (hide)" &&
      r.reservationType !== "No-show"
  );

  // ✔ Total active reservations
  const totalReservations = activeReservations.length;

  // ✔ Total nights — sum of Stay column (check-out minus check-in)
  const totalNights = activeReservations.reduce(
    (total, r) => total + calcStay(r.checkIn, r.checkOut),
    0
  );

  // ✔ Cancelled count (display ONLY)
  const cancelled = reservations.filter(
    (r) =>
      r.reservationType === "Cancelled" ||
      r.reservationType === "Cancelled (hide)" ||
      r.reservationType === "No-show"
  ).length;

  // ✔ Other services — only active
  const otherServices = activeReservations.reduce((sum, r) => {
    return sum + Number(r.otherServicesPrice || 0);
  }, 0);

  // ✔ Total revenue — only active
  const totalRevenue = activeReservations.reduce((sum, r) => {
    return sum + Number(r.totalPrice + r.taxes || r.totalRateWithTax || 0);
  }, 0);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(5, 1fr)",
        gap: "12px",
        marginBottom: "18px",
      }}
    >
      <div style={boxStyle}>
        <h5 style={titleStyle}>Reservations</h5>
        <div style={valueStyle}>{totalReservations}</div>
      </div>

      <div style={boxStyle}>
        <h5 style={titleStyle}>Total Nights</h5>
        <div style={valueStyle}>{totalNights}</div>
      </div>

      <div style={boxStyle}>
        <h5 style={titleStyle}>Cancelled</h5>
        <div style={valueStyle}>{cancelled}</div>
      </div>

      <div style={boxStyle}>
        <h5 style={titleStyle}>Other Services</h5>
        <div style={valueStyle}>PKR {otherServices.toLocaleString()}</div>
      </div>

      <div style={boxStyle}>
        <h5 style={titleStyle}>Total Revenue</h5>
        <div style={valueStyle}>PKR {totalRevenue.toLocaleString()}</div>
      </div>
    </div>
  );
};

export default ReservationStats;
